export const getUrsaIconColorVarName = () => `--sds--ursa-icons--text-color`;
//# sourceMappingURL=getUrsaIconColorVarName.js.map